







































































































import { Component, Vue } from 'vue-property-decorator';
import { TimeAccountStore } from '@/store/timeaccount-store';
import {TimeAccountTeamWeeklyOverviewWeekModel, WeekAppUserDay} from '@/services/api/nswag/stapiclient_generated';
import {sum} from 'lodash';
import {TimeEntryStore} from '@/store/time-entry-store';
import {DateTime} from 'luxon';

@Component({
  methods: {sum},
  components: {},
})
export default class TimeAccountSummary extends Vue {
  delayLoading = false;

  get loading() {
    return TimeAccountStore.loading;
  }

  get isLoaded() {
    return TimeAccountStore.isLoaded;
  }

  get summary() {
    return TimeAccountStore.TimeAccountSummary;
  }

  get todaysAppUserDay(): WeekAppUserDay {
    let todayData = this.summary.currentWeekAppUserDays.filter(_=>_.date.substr(0,10) == TimeEntryStore.selectedDate.toFormat("yyyy-MM-dd"));
    return todayData[0];
  }

  get isNotInFuture() : boolean {
    if (!this.summary || !TimeEntryStore.selectedDate)
      return false;

    return TimeEntryStore.selectedDate.startOf('day') <= DateTime.fromISO(this.summary.dateTo);
  }

  getTodayTooltip(day: WeekAppUserDay): string {
    return 'Gewählter Tag: ' + DateTime.fromISO(day.date).toFormat("dd.MM.yyyy");
  }

  getApprovalTooltip() {
    let toolTipText = '<div class="mb-4">Gewählte Woche (in aktueller Woche Werte bis einschließlich heute)</div>';

    if (this.summary.overtimeIsApproved)
    {
      toolTipText += '<div>Überstunden sind genehmigt</div>';
      if (this.summary.overtimeIsApprovedComment)
      {
        toolTipText+='<div class="font-bold">Kommentar:</div><div>' + this.summary.overtimeIsApprovedComment + '</div>';
      }
    }

    if (this.summary.displayOvertimeIsNotApprovedWarning)
    {
      toolTipText += '<div>Überstunden sind nicht genehmigt</div>';
    }

    return {
      content: toolTipText,
      isHtml: true,
    };
  }
}
